import { makeAutoObservable } from "mobx"
import companyPrintTemplateService from "@services/master-data/companyPrintTemplateService"
import type {
  ICompanyPrintTemplate,
  ICompanyPrintTemplateUpload,
  CompanyPrintTemplateTypeValue,
} from "@models/master-data/companyPrintTemplateModel"

class CompanyPrintTemplateStore {
  detailData: ICompanyPrintTemplate | undefined = undefined
  isLoading = false

  constructor() {
    makeAutoObservable(this)
  }

  async getByType(companyId: number, type: CompanyPrintTemplateTypeValue) {
    this.isLoading = true
    try {
      this.detailData = await companyPrintTemplateService.getByType(
        companyId,
        type
      )
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  async upload(body: ICompanyPrintTemplateUpload) {
    this.isLoading = true
    try {
      this.detailData = await companyPrintTemplateService.upload(body)
      return this.detailData
    } finally {
      this.isLoading = false
    }
  }

  emptyDetail() {
    this.detailData = undefined
  }
}

export default CompanyPrintTemplateStore
